{% block sw_cms_block_top_finder_selectboxes %}
    <div class="sw-cms-block-top-finder-selectboxes">
        <slot name="main">{% block sw_cms_block_top_finder_selectboxes_main %}{% endblock %}</slot>
    </div>
{% endblock %}
